import { render, staticRenderFns } from "./index.vue?vue&type=template&id=66113c82&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=66113c82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66113c82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66113c82')) {
      api.createRecord('66113c82', component.options)
    } else {
      api.reload('66113c82', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=66113c82&scoped=true", function () {
      api.rerender('66113c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/grantAuth/shareHead/index.vue"
export default component.exports